// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import AccessDeniedNoHeader from "../components/AccessDeniedNoHeader";
import { useTranslation } from 'react-i18next';

export default function AccessDeniedView() {
    const { t } = useTranslation();
    return (
        <PageContainer title={t("Access Denied")} showShopToolbar={false}>
            <AccessDeniedNoHeader />
        </PageContainer>
    );
}